/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useMemo, useCallback, useState, useEffect } from "react";

import VirtualList from "rc-virtual-list";

// antd:
import { List, Avatar } from "antd";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

// import {MarkdownField} from "@refinedev/antd";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import rehypeRaw from "rehype-raw";
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
// import {dark, light} from "react-syntax-highlighter/dist/esm/styles/prism";

// import js from "react-syntax-highlighter/dist/esm/languages/hljs/javascript";
// SyntaxHighlighter.registerLanguage("javascript", js);

import AppIcons from "../react/AppIcons.tsx";
// import DivE from "../react/DivE.tsx";
// Redux-hooks:
import { useAppSelector, useAppDispatch } from "../../libs/redux-hooks.ts";
// Reducers:
import { getLng, getDict, getTheme, getAppState, changeAppState, getUser, getSafePtr } from "../../libs/reducer.ts";
// My functions
import fnc from "../../libs/fnc.ts";
// Types:
import type {TuniversalElementProps} from "../../types/Iuigen.d.ts";
import type {Tpermissions} from "../../types/easyTypes.ts";
import DivE from "../react/DivE.tsx";

// const { Option } = Select;
const { rz, $ } = window;

type Tlist = {
  size:"default" | "large" | "small",
  split?:boolean,
  bordered?:boolean,
  virtual?:boolean,
  pagination?:boolean | {[key:string]:any}, // position, align, current, size<'small' | 'default'>, total, pageSize, pageSizeOptions[], responsive, showTotal, simple
  markdownChat?:boolean
};

const RZlist:FC<TuniversalElementProps> = ({attributes}) => {
  RZlist.displayName = "List";
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUser);
  const dct = useAppSelector(getDict);
  const lng = useAppSelector(getLng);
  const theme = useAppSelector(getTheme);
  const safe = useAppSelector(getSafePtr);
  const rlng = (lng === "en" ? "ru" : "en");

  const {rootAttributes, key, fullPath, type, content} = attributes; // onClick, onChange, onRightClick, onHover, onLoad
  const appState = useAppSelector(getAppState(rootAttributes.key)), elState = appState[fullPath];
  const parentPath = rz.strParentFolderName(fullPath || ""), parentState = appState[parentPath];
  const {color, backgroundColor} = elState.attributes;
  const rootNamespace = useMemo(() => (window[rootAttributes.key || rz.strMakeID(24)]), [rootAttributes.key]);

  const permissions = useMemo<Tpermissions>(() => (fnc.checkPermissions(user, attributes)), [user, attributes]);

  const cmpType = useMemo<Tlist>(() => {
    const typ:Tlist = {size: "default", bordered: false};
    (type || "").replace((/(\s+|,|\|)/igm), ";").split(";").forEach((tt) => {
      if (~["small", "large"].indexOf(tt)) { typ.size = tt }
      else if (~["bordered", "borders"].indexOf(tt)) { typ.bordered = true }
      else if (~["virtual", "infinite", "infinite-scroll"].indexOf(tt)) { typ.virtual = true }
      else if (tt === "split") { typ.split = true }
      else if (tt === "pagination") { typ.pagination = true }
      else if (~["markdownChat", "markdownchat", "markdown"].indexOf(tt)) { typ.markdownChat = true }
    });

    if (attributes?.size) { typ.size = attributes.size }
    if (attributes?.bordered) { typ.bordered = (attributes.bordered === "true") }
    if (attributes?.virtual) { typ.virtual = (attributes.virtual === "true") }
    if (attributes?.split) { typ.split = (attributes.split === "true") }
    if (attributes?.pagination) {
      if (rz.arrContains(["true", "false"], attributes.pagination)) { typ.pagination = (attributes.pagination === "true") }
      else if (rz.isString(attributes.pagination) && attributes.pagination.startsWith("{") && attributes.pagination.endsWith("}")) {
        const jsn = rz.objFromJSON(rz.strReplaceAll(attributes.pagination, "'", "\"").trim()); if (jsn) { typ.pagination = jsn }
      }
      else if (rz.isString(attributes.pagination) && rootNamespace && rootNamespace[attributes.pagination]) {
        const clientFNC = rootNamespace[attributes.pagination];
        if (rz.isFunction(clientFNC)) {
          const ret = clientFNC({appkey: rootAttributes.key, attributes, key, user, lng, dct, safe});
          if (!rz.isUndefinedOrNull(ret)) { typ.pagination = ret }
        }
      }
    }
    return typ;
  }, [type, attributes, rootNamespace, rootAttributes.key, key, user, lng, dct, safe]);

  const clsu = useMemo<Array<string>>(() => {
    const userClss = rz.objClone(elState?.userClass || []);
    if ((elState?.disabled || permissions.disabled === true) && !~userClss.indexOf("uk-disabled")) { userClss.push("uk-disabled") }
    if (!rz.arrCompare(userClss, ["rz-width", "uk-width"], "includesAny")) { userClss.push("rz-width-expand") }
    return userClss;
  }, [elState?.disabled, elState?.userClass, permissions.disabled]);

  // const [contentLoaded, setContentLoaded] = useState(false);

  const containerHeight = useMemo<number>(() => {
    if (elState.attributes?.containerHeight) { return (rz.isNumeric(elState.attributes.containerHeight) ? Number(elState.attributes.containerHeight) : elState.attributes.containerHeight) }
    if (attributes?.containerHeight) { return (rz.isNumeric(attributes.containerHeight) ? Number(attributes.containerHeight) : attributes.containerHeight) }

    const desktopEl = $("#virtual-desktop")[0], mainToolbar = $("#layout-main-toolbar")[0];
    // @ts-ignore
    let height = $(desktopEl).innerHeight() - $(mainToolbar).outerHeight() - 2; // Default height = desktop.height - mainToolbar.height - 2
    if (~["container", "cell", "div", "span", "flex", "form", "modal", "space", "tab", "step", "item"].indexOf(parentState?.name)) {
      const parentElement = $("#" + parentState.key);
      if (parentElement[0]) {
        const lastEl = $(parentElement[0]).children().eq(-2);
        if (lastEl[0]) {
          // @ts-ignore
          height = window.innerHeight - ($(lastEl[0]).offset().top + $(lastEl[0]).outerHeight()) - 6;
        }
        else {
          const chTop = $(parentElement[0]).offset().top + parseInt($(parentElement[0]).css("padding-top"), 10) + parseInt($(parentElement[0]).css("padding-bottom"), 10);
          // @ts-ignore
          height = window.innerHeight - chTop - 4;
        }
      }
    }
    return height;
  }, [parentState, attributes, elState.attributes]);

  const itemHeight = useMemo(() => {
    if (elState.attributes?.itemHeight) { return (rz.isNumeric(elState.attributes.itemHeight) ? Number(elState.attributes.itemHeight) : elState.attributes.itemHeight) }
    if (attributes?.itemHeight) { return (rz.isNumeric(attributes.itemHeight) ? Number(attributes.itemHeight) : attributes.itemHeight) }
    return 47; // default
  }, [attributes, elState.attributes]);

  const styl = useMemo<CSS.Properties>(() => {
    const est = {...elState.userStyle};
    if ((elState?.visible === false || permissions.visible === false) && est.display !== "none") { est.display = "none" }
    else if ((elState?.visible === true && permissions.visible !== false) && est.display === "none") { est.display = undefined }
    let clr:string; const allc = (color || "").split("|"); if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    if (!est?.color && clr) { est.color = clr }
    let bclr:string; const allb = (backgroundColor || "").split("|"); if (allb.length > 1) { bclr = (theme === "dark" ? allb[1] : allb[0]) } else { bclr = allb[0] }
    if (!est?.backgroundColor && bclr) { est.backgroundColor = bclr }
    if (!est.boxSizing) { est.boxSizing = "border-box" }
    // @ts-ignore
    if (!est.height) { est.height = containerHeight }
    return est;
  }, [elState?.userStyle, elState?.visible, color, backgroundColor, theme, permissions, containerHeight]);

  const header = useMemo<string | undefined>(() => (
    // Исправлено: локализованный header ищем по ключу header_ru/header_en/... с подчеркиванием.
    elState.attributes["header_" + lng] || elState.attributes.header || elState.attributes["header_" + rlng]
    || elState.attributes["title_" + lng] || elState.attributes.title || elState.attributes["title_" + rlng]
  ), [elState.attributes, lng, rlng]);

  const footer = useMemo<string | undefined>(() => (elState.attributes["footer_" + lng] || elState.attributes.footer || elState.attributes["footer_" + rlng]), [elState.attributes, lng, rlng]);

  const tooltip = useMemo<string | undefined>(() => (elState.attributes["tooltip_" + lng] || elState.attributes.tooltip || elState.attributes["tooltip_" + rlng]), [elState.attributes, lng, rlng]);

  const onScroll = useCallback((e: React.UIEvent<HTMLElement, UIEvent>) => {
    // Исправлено: проверяем достижение низа по реальной высоте viewport, иначе virtual list мог не вызывать onScroll на конце.
    const viewportHeight = e.currentTarget.clientHeight || containerHeight;
    const scrollDiff = e.currentTarget.scrollHeight - e.currentTarget.scrollTop - viewportHeight;
    if (scrollDiff <= 2) {
      if (fnc.config?.isDev) console.log({action: "<List key='" + key + "'> -> onScroll()"});
      if (rootNamespace && (attributes.onScroll || attributes.onscroll) && rootNamespace[attributes.onScroll || attributes.onscroll]) {
        const clientFNC = rootNamespace[attributes.onScroll || attributes.onscroll];
        if (rz.isPromise(clientFNC)) {
          clientFNC({appkey: rootAttributes.key, attributes, key, user, lng, dct, safe}).then((ret) => {
            if (rz.isUndefinedOrNull(ret)) { return }
            if (ret?.err) { console.log(ret.err) }
            if (ret && ret?.state?.fullPath && ret?.state?.newState) {
              dispatch(changeAppState({appkey: rootAttributes.key, fullPath: ret.state.fullPath, newState: ret.state.newState}));
            }
          });
        }
        else if (rz.isFunction(clientFNC)) {
          const ret = clientFNC({appkey: rootAttributes.key, attributes, key, user, lng, dct, safe}); if (rz.isUndefinedOrNull(ret)) { return }
          if (ret?.err) { console.log(ret.err) }
          if (ret && ret?.state?.fullPath && ret?.state?.newState) {
            dispatch(changeAppState({appkey: rootAttributes.key, fullPath: ret.state.fullPath, newState: ret.state.newState}));
          }
        }
      }
    }
  }, [attributes, containerHeight, dct, dispatch, key, lng, rootAttributes.key, rootNamespace, user, safe]);

  const [localRows, setLocalRows] = useState(undefined);
  // Configure rows
  useEffect(() => {
    const createKeys = (rws) => {
      if (rws && rws.length) {
        rws.forEach((rr) => {
          if (!rr.key) {
            if (rr._id || rr.id) { rr.key = (rr._id || rr.id) } else { rr.key = rz.strMakeID(24) }
          }
        });
      }
    };
    const attr = (attributes?.items || attributes?.data || attributes?.rows || attributes?.onLoadData || attributes?.onloaddata || "");
    if (rz.isString(attr) && attr.startsWith("{") && attr.endsWith("}") && elState.loading) {
      const jsnb = (rz.strReplaceAll(attr, "'", "\"")).trim();
      let jsn; try {
        jsn = JSON.parse(jsnb); const okeys = rz.objKeys(jsn);
        if (okeys[0] && rz.isArray(jsn[okeys[0]])) {
          // setRowData(jsn[okeys[0]]);
          createKeys(jsn[okeys[0]]);
          dispatch(changeAppState({appkey: rootAttributes.key, fullPath, newState: {...elState, data: jsn[okeys[0]], loading: false}}));
          if (fnc.config?.isDev) {
            console.log("<List key='" + key + "'> -> onLoadData('" + rootAttributes.key + "'): Loaded " + jsn[okeys[0]].length + " rows");
            // console.log(jsn[okeys[0]]);
          }
        }
      } catch (err) { console.log(err) }
    }
    else if (attr && rootNamespace && rootNamespace[attr] && elState.loading) {
      // elState.loading !!! After this will be called - elState.loading = false => Prevent double calling this
      // if You want to load data again - setState(elState.loading = true)
      const clientFNC = rootNamespace[attr];
      if (rz.isPromise(clientFNC)) {
        clientFNC({appkey: rootAttributes.key, attributes, key, user, lng, dct, safe}).then((ret) => {
          if (ret && rz.isArray(ret)) {
            // setRowData(ret);
            createKeys(ret);
            dispatch(changeAppState({appkey: rootAttributes.key, fullPath, newState: {...elState, data: ret, loading: false}}));
            if (fnc.config?.isDev) {
              console.log("<List key='" + key + "'> -> onLoadData('" + rootAttributes.key + "'): Loaded " + ret.length + " rows");
              // console.log(ret);
            }
          }
        }).catch((err) => { console.log(err) });
      }
      else if (rz.isFunction(clientFNC)) {
        const ret = clientFNC({appkey: rootAttributes.key, attributes, key, user, lng, dct, safe});
        if (ret && rz.isArray(ret)) {
          // setRowData(ret);
          createKeys(ret);
          dispatch(changeAppState({appkey: rootAttributes.key, fullPath, newState: {...elState, data: ret, loading: false}}));
          if (fnc.config?.isDev) {
            console.log("<List key='" + key + "'> -> onLoadData('" + rootAttributes.key + "'): Loaded " + ret.length + " rows");
            // console.log(ret);
          }
        }
      }
    }
    else if (rz.isArray(attr)) {
      const ret = attr.filter((rr) => (rr && (rr.text || rr.title))).map((rr, r) => ({key: "msg-" + r, avatar: rr.avatar || "", text: rr.text || rr.title, description: rr.description || rr.strDate || ""}));
      setLocalRows(ret);
    }
  }, [lng, attributes, key, rootNamespace, user, dispatch, rootAttributes.key, fullPath, elState, dct, safe]);

  const codeComponents = useMemo(() => ({
    code({ node, inline, className, children, ...props }: any) {
      const match = /language-(\w+)/.exec(className || "");

      // Проверяем, является ли блок математическим
      const isMath = className?.includes("math") || className?.includes("katex");

      if (match && !isMath && !inline) {
        return (
          <SyntaxHighlighter key={key + "-SyntaxHighlighter"} PreTag="div" language={match[1]} {...props}>
            {String(children).replace(/\n$/, "")}
          </SyntaxHighlighter>
        )
      }

      return (
        <code className={className} {...props}>
          {children}
        </code>
      );
    }
  }), [key]);

  const convertLatexToMarkdown = useCallback((text) => {
    if (!text) return text;
    let result = text;
    // @ts-ignore
    result = result.replace((/\\\[/gs), "$$$$").replace(/\\\]/g, "$$$$");
    // @ts-ignore
    result = result.replace(/\\\(/g, "$").replace(/\\\)/g, "$");

    // Преобразуем блочные формулы: \[ ... \] → $$ ... $$
    // @ts-ignore
    // result = result.replace((/\\\[(.*?)\\\]/gs), "$$$$$1$$$$");
    // Преобразуем инлайн формулы: \( ... \) → $ ... $
    // @ts-ignore
    // result = result.replace((/\\\((.*?)\\\)/gs), "$$1$");
    // Также обрабатываем другие возможные форматы
    // \begin{equation} ... \end{equation} → $$ ... $$
    // @ts-ignore
    // result = result.replace((/\\begin\{equation\}(.*?)\\end\{equation\}/gs), "$$$$$1$$$$");
    // \begin{align} ... \end{align} → $$ ... $$
    // @ts-ignore
    // result = result.replace((/\\begin\{align\*\}(.*?)\\end\{align\*\}/gs), "$$$$$1$$$$");
    // \begin{gather} ... \end{gather} → $$ ... $$
    // @ts-ignore
    // result = result.replace((/\\begin\{gather\*\}(.*?)\\end\{gather\*\}/gs), "$$$$$1$$$$");
    return result;
  }, []);

  const renderredMarkdown = useCallback((item) => {
    // Исправлено: markdown-режим должен рендерить и item.title, не только item.text.
    if (cmpType.markdownChat && item && item.avatar && (item.text || item.title)) {
      let outText = (item.text || item.title);
      const hasMath = (/[$\\]/).test(outText);
      if (hasMath) { outText = convertLatexToMarkdown(outText) }

      return (
        <Markdown key={key + "-Markdown"}
          remarkPlugins={[remarkGfm, remarkMath]}
          rehypePlugins={[rehypeRaw, rehypeKatex]}
          components={{
            ...codeComponents
            // math: (props) => (<math {...props} />),
            // inlineMath: (props) => (<inlineMath {...props} />)
          }}
        >
          {outText}
        </Markdown>
      )
    }
    return (item.text || item.title)
  }, [cmpType.markdownChat, key, codeComponents, convertLatexToMarkdown]);

  const renderItem = useCallback((item, index) => {
    if (rootNamespace && (attributes.renderItem || attributes.renderitem) && rootNamespace[attributes.renderItem || attributes.renderitem]) {
      const clientFNC = rootNamespace[attributes.renderItem || attributes.renderitem];
      if (rz.isFunction(clientFNC)) {
        const ret = clientFNC({appkey: rootAttributes.key, attributes, key, user, lng, dct, item, index, safe});
        if (!rz.isUndefinedOrNull(ret)) { return ret }
      }
    }
    else if (item && item.avatar && (item.text || item.title)) {
      const itemKey = item.key || ("item-" + (index + 1));
      if (cmpType.markdownChat) {
        return (
          <List.Item key={itemKey} className="rz-padding-10 uk-overflow-auto">
            <div key={itemKey + "-markdown-row"} className="uk-flex uk-flex-top rz-width-1-1">
              <Avatar key={itemKey + "-avatar"} size="large" shape="square" src={"/ui/avatar/" + item.avatar} icon={<AppIcons icopath="fa/FaUserSecret" attrs={{}} />} />
              <div key={itemKey + "-markdown-content"} className="rz-margin-left-10 rz-width-expand">
                <DivE key={itemKey + "-markdown-text"}>{renderredMarkdown(item)}</DivE>
                {(item.description || item.strDate || item.actions) ? (
                  <DivE key={itemKey + "-description"} style={{fontSize: "0.8em"}}>
                    {item.description || item.strDate || null}
                    {item.actions || null}
                  </DivE>
                ) : undefined}
              </div>
            </div>
          </List.Item>
        );
      }
      return (
        <List.Item key={itemKey} className="rz-padding-10 uk-overflow-auto">
          <List.Item.Meta key={itemKey + "-data"}
            avatar={<Avatar key={itemKey + "-avatar"} size="large" shape="square" src={"/ui/avatar/" + item.avatar} icon={<AppIcons icopath="fa/FaUserSecret" attrs={{}} />} />}
            title={item.text || item.title}
            description={(item.description || item.strDate) ? <DivE key={itemKey + "-description"} style={{fontSize: "0.8em"}}>{item.description || item.strDate}</DivE> : undefined}
          />
        </List.Item>
      );
    }
    return (<React.Fragment key={"null-item-" + index} />);
  }, [rootNamespace, attributes, rootAttributes.key, key, user, lng, dct, cmpType.markdownChat, renderredMarkdown, safe]);

  if (cmpType.virtual) {
    return (
      <List key={key} style={styl} className={clsu.join(" ")} uk-tooltip={tooltip}
        size={cmpType.size} bordered={cmpType.bordered} split={cmpType.split}
        header={header ? <DivE key={"header-" + key} className="">{header}</DivE> : undefined}
        footer={footer ? <DivE key={"footer-" + key} className="">{footer}</DivE> : undefined}
      >
        <VirtualList key={key + "-VirtualList"}
          data={localRows || elState.data || []}
          height={containerHeight} itemHeight={itemHeight}
          itemKey="key"
          onScroll={onScroll}
        >
          {renderItem}
        </VirtualList>
      </List>
    );
  }

  return (
    <List
      key={key} style={styl} className={clsu.join(" ")} uk-tooltip={tooltip}
      size={cmpType.size} bordered={cmpType.bordered} split={cmpType.split}
      header={header ? <DivE key={"header-" + key} className="">{header}</DivE> : undefined}
      footer={footer ? <DivE key={"footer-" + key} className="">{footer}</DivE> : undefined}
      // @ts-ignore
      pagination={cmpType.pagination}
      dataSource={localRows || elState.data} renderItem={renderItem}
    />
  );
}

export default RZlist;
/* eslint-enable @typescript-eslint/no-unused-vars */
